import { render } from "./share_overlay.vue?vue&type=template&id=56e7b10c&scoped=true"
import script from "./share_overlay.vue?vue&type=script&lang=js"
export * from "./share_overlay.vue?vue&type=script&lang=js"

import "./share_overlay.vue?vue&type=style&index=0&id=56e7b10c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e7b10c"]])

export default __exports__